import { useDrawer } from '@cast/design-system';

import {
  CreateEdgeLocationDrawer,
  CreateEdgeLocationDrawerProps,
} from './CreateEdgeLocationDrawer';

export const useCreateEdgeLocationDrawer = () => {
  const { open } = useDrawer();

  return {
    openCreateEdgeLocationDrawer: (props: CreateEdgeLocationDrawerProps) =>
      open({ component: CreateEdgeLocationDrawer, props }),
  };
};
